import React from 'react';
import { Card } from 'semantic-ui-react';
import { SFEntityID } from "utils/types";
import { defaultVibrantColor, getColorFromImage } from "utils/colors";

export default class ServicesCardTopBar extends React.Component {

	constructor() {
		super();
		this.state = { vibrantColor: defaultVibrantColor };
	}

	componentDidMount() {
    const imageURL = `../instructor/photo.html?type=S&size=F&id=${encodeURIComponent(this.props.serviceUuid)}`;
    getColorFromImage(imageURL)
      .then(vibrantColor => this.setState({vibrantColor}))
      .catch(e => {}); // eslint-disable-line no-unused-vars
	}

	render() {
		return <Card.Header style={{backgroundColor: this.state.vibrantColor, height: "32px"}} />
	}
}

ServicesCardTopBar.propTypes = {
  serviceUuid: SFEntityID.isRequired
};
